/* @flow */

import type { CmsPage } from "shop-state/types";

import React from "react";
import { Helmet } from "react-helmet-async";
import Wrapper from "components/Wrapper";
import Breadcrumbs from "components/Breadcrumbs";
import { useGetCmsMeta } from "helpers/get-meta";

type Props = {
  cmsPage: CmsPage,
  useBreadcrumbs?: boolean,
};

const CmsPageView = ({ cmsPage, useBreadcrumbs = true }: Props): React$Node => {
  const meta = useGetCmsMeta(cmsPage);

  return (
    <Wrapper>
      <Helmet
        title={meta.title}
        meta={meta.data}
        link={meta.link}
      />

      {useBreadcrumbs && (
        <Breadcrumbs current={cmsPage.contentHeading} />
      )}

      {cmsPage.contentHeading &&
        <h1>{cmsPage.contentHeading}</h1>
      }

      <div dangerouslySetInnerHTML={{ __html: cmsPage.content }} className="typography" />
    </Wrapper>
  );
};

export default CmsPageView;
